import { afterNextRender, Component, signal, Signal } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { fromStore } from 'angular/app/core/store';
import { ModalService } from '../../core/services/modal.service';
import { AuthService } from '../../core/services/auth.service';
import { ToastService } from '../../core/services/toast.service';
import { LogoutBaseComponent } from '../../shared/components/logout-base/logout-base.component';
import { PublicAppSection } from '../../core/store/ui/ui.state';

@Component({
  selector: 'app-public-navbar-links',
  template: `
    <app-dropdown-menu></app-dropdown-menu>
    
    <app-link-highlight
      routerLink="/louer-salle"
      [routerLinkActiveOptions]="{ exact: false }"
      >Rechercher une salle</app-link-highlight
      >
    
      @if (
        (isLoggedIn$ | async) === false &&
        (B2C$ | async) === false &&
        isPlatformBrowser()
        ) {
        <app-button
          id="login-button"
          routerLink="/auth/connexion"
          variant="secondary"
          >Se connecter
        </app-button>
      }
    
      @if (
        (isLoggedIn$ | async) === false &&
        (B2C$ | async) === true &&
        vendorSlug()
        ) {
        <app-link-highlight
          id="login-button"
          routerLink="/auth/connexion"
          >Espace hôte
        </app-link-highlight>
      }
      @if ((isLoggedIn$ | async) === true) {
        <app-link-highlight
          [attr.data-cy]="'navbar-admin'"
          routerLink="/reservations"
          >
          Admin
        </app-link-highlight>
      }
      @if (isLoggedIn$ | async) {
        <app-link-highlight
          id="logout-button"
          (onClick)="logout()"
          >
          <i class="fal fa-sign-out"></i>
        </app-link-highlight>
      }
    `,
  styles: [],
  standalone: false,
})
export class PublicNavbarLinksComponent extends LogoutBaseComponent {
  isLoggedIn$: Observable<boolean> = this.store.select(fromStore.isLoggedIn);
  B2C$: Observable<boolean> = this.store
    .select(fromStore.selectPublicAppSection)
    .pipe(
      map((publicAppSection: PublicAppSection) => {
        return publicAppSection === PublicAppSection.B2C;
      }),
    );
  vendorSlug: Signal<string | null> = this.store.selectSignal(
    fromStore.selectVendorSlug,
  );
  isPlatformBrowser = signal(false);

  constructor(
    private store: Store,
    modalService: ModalService,
    authService: AuthService,
    toastService: ToastService,
  ) {
    super(modalService, authService, toastService);

    afterNextRender(() => {
      this.isPlatformBrowser.set(true);
    });
  }
}
